/**
 * 环境变量工具类
 * 统一管理环境变量的使用
 */

// 获取API基础URL
export const getApiBaseUrl = () => {
  return import.meta.env.VITE_API_BASE_URL
}

// 获取应用标题
export const getAppTitle = () => {
  return import.meta.env.VITE_APP_TITLE || '跳绳小凡赛事系统'
}

// 获取应用版本
export const getAppVersion = () => {
  return import.meta.env.VITE_APP_VERSION || '1.0.0'
}

// 是否为开发环境
export const isDevelopment = () => {
  return import.meta.env.DEV
}

// 是否为生产环境
export const isProduction = () => {
  return import.meta.env.PROD
}

// 获取调试模式
export const isDebugMode = () => {
  return import.meta.env.VITE_APP_DEBUG === 'true'
}

// 获取日志级别
export const getLogLevel = () => {
  return import.meta.env.VITE_APP_LOG_LEVEL || 'info'
}

// 打印环境信息（仅在开发环境）
export const logEnvInfo = () => {
  if (isDevelopment()) {
    console.log('🚀 环境信息:', {
      mode: import.meta.env.MODE,
      apiBaseUrl: getApiBaseUrl(),
      appTitle: getAppTitle(),
      appVersion: getAppVersion(),
      debug: isDebugMode(),
      logLevel: getLogLevel()
    })
  }
}
